import { render, staticRenderFns } from "./OrganisationUsersList.vue?vue&type=template&id=e08fcb98"
import script from "./OrganisationUsersList.vue?vue&type=script&lang=js"
export * from "./OrganisationUsersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports